<template>
  <a-layout id="components-layout-demo-top" class="layout">
    <a-layout-header :style="{ position: 'fixed', zIndex: 1, width: '100%' }">
      <div class="uc-header">
        <div class="logo">
          <szn-logo mode="simple" title="三只鸟云课堂 | 在线学习" title-color="rgba(255,255,255,.8)"></szn-logo>
        </div>
        <div class="menu">
          <a-menu
            theme="dark"
            mode="horizontal"
            :default-selected-keys="['1']"
            :style="{ lineHeight: '64px' }"
          >
            <a-menu-item key="1"> 学习中心</a-menu-item>
            <!-- <a-menu-item key="2"> 学习计划 </a-menu-item>
            <a-menu-item key="3"> 个人中心</a-menu-item> -->
          </a-menu>
        </div>
        <div class="extra">
          <div class="userinfo">
            <a-avatar shape="square" :src="userinfo.avatar" />
            <div class="info">
              <div class="nickname">{{userinfo.nickname}}</div>
              <div class="mobile">{{userinfo.mobile}}</div>
            </div>
          </div>
          <div class="exit" @click="logout()"><a-icon type="logout" /> 退出</div>
        </div>
      </div>
    </a-layout-header>
    <a-layout-content class="uc-content">
      <div class="uc-content-view">
          <router-view></router-view>
      </div>
    </a-layout-content>
    <a-layout-footer class="uc-footer">
       Copyright 2019 重庆三只鸟科技有限公司 版权所有.渝ICP备2020010534号-1
    </a-layout-footer>
  </a-layout>
</template>
<style lang="less" scoped>
.uc-header {
  width: 1230px;
  margin: 0 auto;
  display: flex;
  .logo {
    flex-shrink: 0;

    margin-right: 48px;
  }
  .menu{
      flex:1;
  }
  .extra{
      flex-shrink: 0;
      display: flex;
      .userinfo{
        color:rgba(255,255,255,.8);
        display: flex;
        align-items: center;
        .info{
          padding-left:8px;
          display: flex;
          flex-direction: column;
          line-height: 20px;
          .nickname{
            font-weight: 700;
          }
          .mobile{
            font-size: 12px;
          }
        }
      }
      .exit{
        margin-left: 12px;
          width:64px;
          color:#fff;
          text-align:center;
          cursor: pointer;
          &:hover{
              background-color: rgba(255,255,255,.9);
              color:rgba(0,0,0,1);
          }
      }
  }
}
.uc-content{
  margin-top: 64px;
    .uc-content-view{
        padding:4px 0 12px 0;
        width:1230px;
        margin: 0 auto;
        height:100%;
      

    }
}
.uc-footer{
    height: 48px;
    text-align:center;
    margin:0;
    padding:0;
    line-height: 48px;
}
</style>

<script>
import SznLogo from "@/components/Logo.vue";
export default {
  components: {
    SznLogo,
  },
  data(){
    return {
      userinfo:{}
    }
  },
  created(){
    this.userinfo = this.$store.get('userinfo')
  },
  methods:{
    logout(){
      this.$store.clearAll();
      this.$router.push('/')
    }
  }
};
</script>